import { PrimaryButton } from '../components/Uikit/PrimaryButton';
import { VFC } from 'react';
import { useNavigate } from 'react-router-dom';
// import logo_panda from '../../public/img/logo_panda.png';

const OrderComplete: VFC = () => {
  const navigate = useNavigate();
  return (
    <div className='mx-auto my-0 max-w-xl relative py-0 px-4 text-center w-full sm:max-w-5xl'>
      <div className='text-left max-w-md mx-auto'>
        <h1 className='font-bold text-2xl mt-0'>予約完了</h1>
        <p className='mt-6'>ご予約ありがとうございます。</p>
        <p>画面上部バナーの「注文履歴」から予約内容をご確認できます。</p>
        <div className='text-left mt-4'>
          <p>※ 予約のキャンセル方法</p>
          <p>前日までの予約キャンセルは「注文履歴」から承っております。（当日キャンセルは、店舗にお電話ください）</p>
        </div>
        <div className='text-left mt-4'>
          <p>※ 商品の準備が難しくなった場合</p>
          <p>ショートメッセージ または 電話にてご連絡致します。</p>
        </div>
        <div className='flex justify-center mt-4'> {/* ここを変更 */}
          <img
            src={'/img/logo_panda.png'}
            alt='logo'
            width='120px'
            style={{ marginBottom: '40px' }}
          />
        </div>
        <div className='h-8 sm:h-12 text-center'>
          <PrimaryButton label={'メニューに戻る'} onClick={() =>  navigate('/')} />
        </div>
      </div>
    </div>
  );
};

export default OrderComplete;
